const FormatProductsItems = (products) => {
  const productsList = products.map(({ imageUrl, name, ...rest }) => ({
    imageUrl,
    name,
    productUrl: '#',
    ...rest,
    colProps: {},
    rating: {},
    className: '',
  }));
  return productsList;
};

export default FormatProductsItems;
